import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, FieldArray, reduxForm } from "redux-form";
import AppWrapper from "../../Common/AppWrapper/index.jsx";
import { CopyNumberDeterminationIdentifier } from "./CopyNumberDeterminationIdentifier.jsx";
import { CopyNumberDeterminationSequence } from "./CopyNumberDeterminationSequence.jsx";
import { CopyNumberDeterminationForm } from "./CopyNumberDeterminationForm";
import CopyNumberDeterminationDescription from "./CopyNumberDetermination-Description.jsx";

import * as assayActions from "../../../actions/assays.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import _ from "underscore";

import "../AssayCreate.scss";

const styles = (theme) => ({
  progress: {
    marginLeft: theme.spacing(2),
  },
});

export class CopyNumberDeterminationComponent extends React.Component {
  componentWillUnmount() {
    const { actions } = this.props;
    actions.clearMessage();
  }
  onSubmit = (values, dispatch) => {
    return dispatch(assayActions.processGetNewAssays(values));
  };

  render() {
    const {
      formObj,
      classes,
      handleSubmit,
      pristine,
      submitting,
      validatedAssayDetails,
      actions
    } = this.props;
    const targetByValue = formObj && formObj.values && formObj.values.targetBy;

    const btnSubmitClass = classNames({
      "btn-submit float-right": !submitting,
      "btn-submit float-right btn-submitting": submitting,
    });

    return (
      <div id="copynumberdetermination-form">
        <div className="row target-by">
                <div className="col ">
                  <strong>Enter Target by:&nbsp;</strong>
                  <div className="form-check form-check-inline">
                    <Field
                      className="form-check-input"
                      component="input"
                      type="radio"
                      name="targetby"
                      value="identifier"
                      onChange ={()=>actions.clearValidationMessages()}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="inlineCheckbox1"
                    >
                      Identifier
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <Field
                      className="form-check-input"
                      component="input"
                      type="radio"
                      name="targetby"
                      value="sequence"
                      onChange ={()=>actions.clearValidationMessages()}

                    />
                    <label
                      className="form-check-label"
                      htmlFor="inlineCheckbox2"
                    >
                      Sequence
                    </label>
                  </div>
                </div>
              </div>
        <FieldArray
          name="copyNumberDeterminationForm"
          custom={this.props}
          component={CopyNumberDeterminationForm}
        />
        <div className="row">
          <div className="col">
            <button
              type="button"
              className={btnSubmitClass}
              disabled={
                (pristine || submitting) && _.isEmpty(validatedAssayDetails)
              }
              onClick={handleSubmit(this.onSubmit.bind(this))}
            >
              {!submitting ? "SUBMIT" : "SUBMITTING"}
              {submitting && (
                <CircularProgress
                  className={classes.progress}
                  size={20}
                  thickness={4}
                />
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

CopyNumberDeterminationComponent.propTypes = {
  formObj: PropTypes.object,
  handleSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  actions: PropTypes.object,
};

const epochDate = new Date().getTime();

const stateToProps = (state) => ({
  formObj: state.form["frmCopyNumberDetermination"],
  validatedAssayDetails:
    (state.assays &&
      state.assays.validatedAssayDetails &&
      state.assays.validatedAssayDetails.data) ||
    {},
  initialValues: {
    applicationType: "CopyNumberDetermination",
    targetby: "identifier",
    copyNumberDeterminationForm: [
      {
        
        copynumberdeterminationidentifier: {
          genome: "Home sapiens",
          fluorophores: "FAM",
          created_at: epochDate,
          assayType: "Gene",
          uuid: "",
        },
        copynumberdeterminationsequence: {
          assayTargetName: "",
          genome: "Home sapiens",
          fluorophores: "FAM",
          created_at: epochDate,
          assayType: "DnaSequence",
        },
      },
    ],
  },
});

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(assayActions, dispatch),
});

const onSubmit = (values, dispatch) => {
  dispatch(assayActions.processGetNewAssays(values));
};

CopyNumberDeterminationComponent = reduxForm({
  form: "frmCopyNumberDetermination",
  enableReinitialize: true,
  onSubmit,
})(CopyNumberDeterminationComponent);

CopyNumberDeterminationComponent = withStyles(styles)(
  CopyNumberDeterminationComponent
);

CopyNumberDeterminationComponent = connect(
  stateToProps,
  dispatchToProps
)(CopyNumberDeterminationComponent);

const CopyNumber = () => {
  return (
    <AppWrapper
      id="copynumberdetermination"
      pageTitle="Copy Number Determination"
      pageKeywords="Copy Number Determination, design engine, custom assays"
      pageDescription="Bio-Rad’s ddPCR Copy Number Determination Assays offer high precision and resolution to discriminate between small changes in copy number and can easily detect small fold changes in CNV from 5 to 6 copies."
    >
      <div id="bg">
        <div id="bg-inner"></div>
      </div>
      <div className="container main-content">
        <div className="hero">
          <h2 className="h4">ASSAY DESIGN ENGINE</h2>
          <h1>Copy Number Determination</h1>
        </div>

        <CopyNumberDeterminationComponent />
        <CopyNumberDeterminationDescription />
      </div>
    </AppWrapper>
  );
};

export default CopyNumber;
